export default __webpack_public_path__ + "static/Types-of-people-youll-meet-on-a-plane-airport-74d1708a47e3a5ec2679392e329c5c02.jpg";